import * as priceFragments from '@/services/price/fragments';
import service, { IComponent } from '@/services/component';
import { store as DirtyCheckComposer } from '@/composers/dirty-check';
import { diffIdsRemoved, promiseError } from '@/store/utils';
import { IStateComponent } from './types';

const formatComponent = (data: IComponent): IComponent => (
  JSON.parse(
    JSON.stringify({
      name: '',
      notes: '',
      ...data,

      // provide defaults for database nullable values
      prices: data.prices || [],
      properties: data.properties || [],
      vendors: data.vendors || [],
    }),
  )
);

export default () => DirtyCheckComposer({
  namespaced: true,
  state: () => ({
    data: {},
    saved: {},
    vendors: [] as any,
  } as IStateComponent),
  mutations: {
    CREATE() {
      //
    },
    LOAD(state: IStateComponent, component: IComponent) {
      state.data = formatComponent(component);
      state.saved = formatComponent(component);
    },
    REMOVE(state: IStateComponent) {
      // reset all data (prevents isDirty from being true)
      state.data = formatComponent({} as IComponent);
      state.saved = formatComponent({} as IComponent);
    },
    SAVE(state: IStateComponent) {
      state.saved = {
        ...JSON.parse(
          JSON.stringify(state.data),
        ),
      };
    },
  },
  actions: {
    create: ({ commit }: any) => (
      service.create({
        name: 'Component name',
      })
      .then(created => {
        commit('CREATE', created);
        return created;
      })
      .catch(promiseError('COMPONENT_CREATE', commit))
    ),
    load: ({ commit }: any, id: string) => (
      service.get(id, `
        id
        name
        notes
        properties
        assets (
          order_by: {
            index: asc_nulls_last
          }
        ) {
          id
          src
          index
        }
        vendors (
          order_by: {
            vendor: {
              name: asc
            }
          }
        ) {
          id
          properties
          vendor {
            id
            name
          }
        }
        ${priceFragments.query()}
      `)
      .then(result => {
        commit('LOAD', result);
        return result;
      })
      .catch(promiseError('COMPONENT_LOAD', commit))
    ),
    remove: ({ commit }: any, id: string) => (
      service
        .remove(id)
        .then(() => commit('REMOVE'))
        .catch(promiseError('COMPONENT_REMOVE', commit))
    ),
    save: ({ commit, state }: any) => {
      const { data, saved } = state;
      return service
        .update(data.id, {
          component: {
            ...data,

            // assets are a database view not a linked record
            // therefore remove asset data
            assets: undefined,
            prices: undefined,
          },
          deleteVendorIds: diffIdsRemoved(data.vendors, saved.vendors),

          // add pricing payload
          priceRemoveIds: diffIdsRemoved(data.prices, saved.prices),
          prices: data.prices.map((price: any) => ({
            ...price,
            type: 'component',
            type_id: data.id,
          })),
        })
        .then(() => commit('SAVE'))
        .catch(promiseError('COMPONENT_SAVE', commit));
    },
  },
});
